/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 13/08/2025.
 */
import React from 'react'
import { Button } from 'antd'

type Props = { onClose?: () => void }
export const DeviceUnAvailable = ({ onClose }: Props) => {
  return (
    <div className="container-fluid px-0">
      <div className="row" style={{}}>
        <div className="col-12">
          <h4>Device Synchronization Required</h4>
          <p className="mt-3">To complete this action, the device needs to be online and synced.</p>
          <p className="mt-3 fw-bold">To continue:</p>
          <ul>
            <li className="mt-1">Retrieve the device and complete a data sync, or</li>
            <li className="mt-1">Contact the participant to open the app, while online, and initiate a data sync</li>
          </ul>
          <p>Once synced, you can return here to finish the process.</p>
        </div>

        <div className="col-12 mt-6 d-flex justify-content-end">
          <Button onClick={onClose} type="primary" className="px-4">
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}
